export const iconFontAwesomeConstructionHammer = (
	<i className="fa-solid fa-hammer"></i>
);
